import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { defaultSize, rotationEnum, sizePropsTypes } from './icons.constants';

const AlignIcon = ({ size = defaultSize, direction = IconDirection.DOWN, className, ...props }) => (
  <svg
    className={clsx(rotationEnum[direction], className)}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 5V15M12 15L8 11M12 15L16 11M5 19H19"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

AlignIcon.propTypes = {
  ...sizePropsTypes,
  direction: PropTypes.oneOf(Object.keys(rotationEnum)),
  className: PropTypes.string,
};

export default memo(AlignIcon);
